export const Disclaimer = 'https://www.volcengine.com/docs/6348/68916'; // 免责声明
export const ReversoContext = 'https://www.volcengine.com/docs/6348/68918'; // 反向上下文
export const UserAgreement = 'https://www.volcengine.com/docs/6348/128955'; // 用户协议

/**
 * @note 统一的API基础路径配置
 *       开发环境和生产环境使用不同的配置
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (() => {
    if (typeof window === 'undefined') {
      return process.env.RTC_BACKEND_BASE || 'http://localhost:3001'; // SSR 默认或环境覆盖
    }
    const { origin } = window.location;
    // 本地开发: 默认前端 3000, 后端 3001
    if (/^https?:\/\/(localhost|127\.0\.0\.1):3000$/i.test(origin)) {
      return (
        (window as any).__RTC_BACKEND_BASE__ ||
        process.env.RTC_BACKEND_BASE ||
        'http://localhost:3001'
      );
    }
    // 生产环境: 与页面同域
    return origin;
  })();

/**
 * @note 反馈API服务器地址
 *       开发环境使用本地服务器
 *       生产环境使用与页面同域的地址
 */
export const FEEDBACK_API_BASE =
  process.env.REACT_APP_FEEDBACK_API_BASE ||
  (() => {
    if (typeof window === 'undefined') {
      return process.env.FEEDBACK_API_BASE || 'http://localhost:8080';
    }
    const { origin } = window.location;
    // 本地开发: 使用8080端口
    if (/^https?:\/\/(localhost|127\.0\.0\.1):\d+$/i.test(origin)) {
      return (
        (window as any).__FEEDBACK_API_BASE__ ||
        process.env.FEEDBACK_API_BASE ||
        'http://localhost:8080'
      );
    }
    // 生产环境: 与页面同域
    return origin;
  })();

// 注意: 如果环境变量显式设置为空字符串(""), 也应被视为已配置
const _envProxyHost = process.env.REACT_APP_AIGC_PROXY_HOST;

export const AIGC_PROXY_HOST =
  _envProxyHost !== undefined
    ? _envProxyHost
    : (() => {
        if (typeof window === 'undefined') {
          return process.env.RTC_BACKEND_BASE || 'http://localhost:3001';
        }
        const { origin } = window.location;
        // 本地开发: 默认前端 3000, 后端 3001
        if (/^https?:\/\/(localhost|127\.0\.0\.1):3000$/i.test(origin)) {
          return (
            (window as any).__RTC_BACKEND_BASE__ ||
            process.env.RTC_BACKEND_BASE ||
            'http://localhost:3001'
          );
        }
        // 生产环境: 与页面同域, 加 /api 前缀走反代
        return `${origin}/api`;
      })();

export interface IScene {
  icon: string;
  name: string;
  questions: string[];
  agentConfig: Record<string, any>;
  llmConfig: Record<string, any>;
  asrConfig: Record<string, any>;
  ttsConfig: Record<string, any>;
}

// 应用运行时配置（例如默认场景）
export interface AppRuntimeConfig {
  defaultSceneId?: string;
}

// 读取本地 JSON 配置，允许被 window.__APP_CONFIG__ 或环境变量覆盖
// 注意：为了兼容 SSR 与构建期替换，这里使用可选链并做多重兜底
let appRuntimeConfig: AppRuntimeConfig = { defaultSceneId: 'Custom' };
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const json = require('./app.config.json');
  appRuntimeConfig = { ...appRuntimeConfig, ...(json || {}) };
  // 运行时覆盖
  if (typeof window !== 'undefined' && (window as any).__APP_CONFIG__) {
    appRuntimeConfig = { ...appRuntimeConfig, ...(window as any).__APP_CONFIG__ };
  }
  if (process.env.REACT_APP_DEFAULT_SCENE_ID) {
    appRuntimeConfig.defaultSceneId = process.env.REACT_APP_DEFAULT_SCENE_ID;
  }
} catch {}

export const APP_CONFIG: Readonly<AppRuntimeConfig> = Object.freeze(appRuntimeConfig);
